import React from "react";

function onEnabled(){
    return (
      <svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 24 24" fill="none">
      <path d="M12.2358 23C18.311 23 23.2358 18.0751 23.2358 12C23.2358 5.92487 18.311 1 12.2358 1C6.16071 1 1.23584 5.92487 1.23584 12C1.23584 18.0751 6.16071 23 12.2358 23Z" stroke="#14C415" stroke-width="1.5"/>
      <path d="M12.2397 7.26208V11.5765" stroke="#14C415" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M14.8588 7.96936C15.7256 8.52604 16.3881 9.34933 16.7464 10.3152C17.1047 11.2811 17.1393 12.3373 16.8452 13.3246C16.544 14.3123 15.9334 15.1772 15.1035 15.7917C14.2736 16.4063 13.2683 16.738 12.2356 16.738C11.203 16.738 10.1976 16.4063 9.3677 15.7917C8.5378 15.1772 7.92725 14.3123 7.62601 13.3246C7.33189 12.3373 7.36658 11.2811 7.72485 10.3152C8.08313 9.34933 8.74558 8.52604 9.61241 7.96936" stroke="#14C415" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    )
}
export default onEnabled;